import { render, staticRenderFns } from "./sigin.vue?vue&type=template&id=e96a85d8&scoped=true&"
import script from "./sigin.vue?vue&type=script&lang=js&"
export * from "./sigin.vue?vue&type=script&lang=js&"
import style0 from "./sigin.vue?vue&type=style&index=0&id=e96a85d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96a85d8",
  null
  
)

export default component.exports